<template>
  	<div id="redEnvelopeRecord">
  		<mt-header fixed :title="$t('已配置红包')">
        <mt-button icon="back" slot="left" @click.native="$router.back()"></mt-button>
      </mt-header>
      <div ref="main_list" class="main_list">
        <div class="page-loadmore-wrapper" ref="wrapper" :style="{ height: wrapperHeight + 'px' }">
          <mt-loadmore :top-method="loadTop" @top-status-change="handleTopChange"
             :bottom-method="loadBottom"
              @bottom-status-change="handleBottomChange" :bottom-all-loaded="allLoaded" ref="loadmore" :auto-fill="false">
            <ul class="content_detail main_show">
              <li style="position: relative;" @click="redEnvelopeDetail(item.red_envelope_id,item.img_url)" v-for="(item,index) in cataList" :key=index>
                <div>
                  <span class="currency_name">
                      <span class="receive wx_fontSize3">No.{{index+1}}</span>
                      <span class="form wx_fontSize2">{{ item.create_time | parseTime}}</span>
                  </span>
                  <span class="balance wx_rt">
                    <img v-bind:src="item.img_url" alt="" class="coinImg">
                  </span>
                </div>
                <div class="bg">
                  <span class="currency_name">
                      <span class="receive wx_fontSize3">{{item.coin_symbol}}:{{item.total_amount | numFilter}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{$t("数量")}}:{{item.total_num}}</span>
                      <span class="form wx_fontSize2">{{item.wish}}</span>
                  </span>
                </div>
              </li>
            </ul>
            <div slot="top" class="mint-loadmore-top">
              <span v-show="topStatus !== 'loading'" :class="{ 'is-rotate': topStatus === 'drop' }">↓</span>
              <span v-show="topStatus === 'loading'">
                <mt-spinner type="snake"></mt-spinner>{{$t('正在刷新...')}}
              </span>
            </div>
            <div slot="bottom" class="mint-loadmore-bottom">
              <span v-show="bottomStatus !== 'loading'" :class="{ 'is-rotate': bottomStatus === 'drop' }"></span>
              <span v-show="bottomStatus === 'loading'">
                <mt-spinner type="snake"></mt-spinner>{{$t('正在加载...')}}
              </span>
            </div>
          </mt-loadmore>
        </div>
      </div>
  	</div>
</template>

<script>
import { Toast } from "mint-ui";
import { httpRedEnvelopeRecords } from "@/api/index";
import { numFilter } from "@/filters/index";
import { parseTime } from "@/utils/index";
export default {
  data:function(){
    return{
      cataList:[],
      pageNo:1,
      array_pages:'',
      allLoaded: false,
      bottomStatus: '',
      wrapperHeight: 0,
      topStatus: '',
      translate: 0,
      moveTranslate: 0
    }
  },
  mounted(){
    this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top;
  },
  activated(){
    this.initData(1);
  },
  methods:{
    redEnvelopeDetail(id,img_url){
      this.$router.push({ path: "/redEnvelopeDetail", query: { id: id ,img_url:img_url} });
    },
    handleBottomChange(status) {
      this.bottomStatus = status;
    },
    loadBottom() {
      var _this = this
      setTimeout(() => {
        if (_this.pageNo*10 <= _this.array_pages) {
          _this.pageNo++;
          _this.initData(_this.pageNo)
        } else {
          _this.allLoaded = true;
        }
        _this.$refs.loadmore.onBottomLoaded();
      }, 1500);
    },
    handleTopChange(status) {
      this.moveTranslate = 1;
      this.topStatus = status;
    },
    translateChange(translate) {
      const translateNum = +translate;
      this.translate = translateNum.toFixed(2);
      this.moveTranslate = (1 + translateNum / 70).toFixed(2);
    },  
    loadTop() {
      var _this = this
      setTimeout(() => {
        _this.initData(1);
        _this.allLoaded = false;
        _this.pageNo = 1;
             _this.$refs.loadmore.onTopLoaded();
      }, 1500);
    },
    initData: function(pageNo) {
      httpRedEnvelopeRecords({'limit_begin':0,'limit_end':pageNo*10})
      .then(res => {
        this.cataList = res.data.list;
        this.array_pages = res.data.count;
      })
      .catch(() => {});
    },
  }
}
</script>

<style scoped>
#redEnvelopeRecord{width:100%;padding-top: 40px;}
.mint-header{background: #fff;color:#212529;border-bottom: 1px solid #e3e8ed;}
.mint-button--default{color:#656b79 !important;}
.main_show{width:100%;}
.childList{width:80%;margin-left: 20%;display:none;}  
.content_detail{width:calc(100% - 30px);margin-left: 15px;}
.content_detail li{background:#fff;margin-top: 20px;background-image: url('../../assets/img/coinDetail/bg_bizhongxiangqing.png');height:100%;background-size: cover;border-radius: 6px;padding:0 15px;margin-bottom: 10px;}
.bg{margin-top: 15px;}
.currency_name{position: relative;width:80%;height:70px;display: inline-block;color:#fff;}
.receive{position: absolute;top:10px;}
.form{position: relative;top:35px;}
.amount_of{width:20%;text-align: right;padding:5px 0;border:1px solid #1296db;text-align: center;margin-top: 17px;}
.balance{width:20%;line-height: 70px;text-align: right;}
.balance img{width:25px;height: 25px;}
.balance .coinImg{width:35px;height:35px;border-radius: 50%;position: relative;top:10px;}
</style>